export const items = [
  {
    id: "1",
    img: "https://main-cdn.sbermegamarket.ru/big2/hlr-system/193/944/739/822/517/28/600003901038b0.jpeg",
    title: "Кружка Hello Kitty Star",
    cost: "500",
    category: "K",
    desc: "Код товара: 438322323",
  },
  {
    id: "2",
    img: "https://nazya.com/anyimage/img.alicdn.com/imgextra/i1/1718453595/TB22z3uaqLN8KJjSZFGXXbjrVXa_!!1718453595.jpg",
    title: "Игрушка Hello Kitty ST",
    cost: "899",
    category: "I",
    desc: "Код товара: 1253633",
  },
  {
    id: "3",
    img: "http://igrushka-store.ru/upload/img/products/0218559_1.jpg",
    title: "Игрушка Hello Kitty LB",
    cost: "599",
    category: "I",
    desc: "Код товара: 438326623",
  },
  {
    id: "4",
    img: "https://images.asos-media.com/products/hello-kitty-penna-10-colori/9237967-1-multi?$n_750w$&wid=750&hei=750&fit=crop",
    title: "Ручка Hello Kitty Star",
    cost: "250",
    category: "P",
    desc: "Код товара: 438322323",
  },
  {
    id: "5",
    img: "http://townsquare.media/site/398/files/2017/12/GettyImages-825471026.jpg",
    title: "Брелок Hello Kitty Sun",
    cost: "50",
    category: "B",
    desc: "Код товара: 438322323",
  },
  {
    id: "6",
    img: "https://avatars.mds.yandex.net/get-mpic/5235242/img_id2823243332125319008.jpeg/orig",
    title: "Брелок Hello Kitty Love",
    cost: "80",
    category: "B",
    desc: "Код товара: 438322323",
  },
  {
    id: "7",
    img: "http://g03.s.alicdn.com/kf/HT1fCKOFOJaXXagOFbXU/201126614/HT1fCKOFOJaXXagOFbXU.jpg?size=47967&amp;height=387&amp;width=683&amp;hash=f1ae7e2b1a15c1dab47262a6beb12f5c",
    title: "Кружка Hello Kitty Full",
    cost: "570",
    category: "K",
    desc: "Код товара: 438322323",
  },
  {
    id: "8",
    img: "https://avatars.mds.yandex.net/get-mpic/4407580/img_id2317600572119486446.jpeg/orig",
    title: "Ручка Kuromi",
    cost: "250",
    category: "P",
    desc: "Код товара: 438322323",
  },
  {
    id: "9",
    img: "https://main-cdn.sbermegamarket.ru/big2/hlr-system/193/944/739/822/517/28/600003901038b0.jpeg",
    title: "Кружка Hello Kitty Star",
    cost: "2000",
    category: "K",
    desc: "Код товара: 438322323",
  },
  {
    id: "10",
    img: "https://nazya.com/anyimage/img.alicdn.com/imgextra/i1/1718453595/TB22z3uaqLN8KJjSZFGXXbjrVXa_!!1718453595.jpg",
    title: "Игрушка Hello Kitty ST",
    cost: "599",
    category: "I",
    desc: "Код товара: 1253633",
  },
  {
    id: "11",
    img: "http://igrushka-store.ru/upload/img/products/0218559_1.jpg",
    title: "Игрушка Hello Kitty LB",
    category: "I",
    cost: "399",
    desc: "Код товара: 438326623",
  },
  {
    id: "12",
    img: "https://images.asos-media.com/products/hello-kitty-penna-10-colori/9237967-1-multi?$n_750w$&wid=750&hei=750&fit=crop",
    title: "Ручка Hello Kitty Star",
    category: "P",
    cost: "650",
    desc: "Код товара: 438322323",
  },
  {
    id: "13",
    img: "http://townsquare.media/site/398/files/2017/12/GettyImages-825471026.jpg",
    title: "Брелок Hello Kitty Sun",
    cost: "400",
    category: "B",
    desc: "Код товара: 438322323",
  },
  {
    id: "14",
    img: "https://avatars.mds.yandex.net/get-mpic/5235242/img_id2823243332125319008.jpeg/orig",
    title: "Брелок Hello Kitty Love",
    cost: "800",
    category: "B",
    desc: "Код товара: 438322323",
  },
  {
    id: "15",
    img: "http://g03.s.alicdn.com/kf/HT1fCKOFOJaXXagOFbXU/201126614/HT1fCKOFOJaXXagOFbXU.jpg?size=47967&amp;height=387&amp;width=683&amp;hash=f1ae7e2b1a15c1dab47262a6beb12f5c",
    title: "Кружка Hello Kitty Full",
    cost: "740",
    category: "K",
    desc: "Код товара: 438322323",
  },
  {
    id: "16",
    img: "https://avatars.mds.yandex.net/get-mpic/4407580/img_id2317600572119486446.jpeg/orig",
    title: "Ручка Kuromi",
    cost: "333",
    category: "P",
    desc: "Код товара: 438322323",
  },
];
